import { Container } from "reactstrap";
import AppPageHeader from "../../../../components/Headers/AppPageHeader";
import BasicTableView from "../../CloudListView/BasicTableView";
import IconButton from "../../../../elements/IconButton";
import API from "../../../../api/api/API";
import { newToastEvent } from "../../../../utils/ToastUtil";
import Cookies from "js-cookie";

// Taken from GC-API and modified to include readable names
const RedisDatabasesList: Record<
  string,
  { db: number; name: string; ttl: number }
> = {
  TenantPermissionProfile: {
    db: 1,
    ttl: 3600,
    name: "Tenant Permission Profiles ",
  },
  Workspace: {
    db: 2,
    ttl: 7200,
    name: "Workspaces",
  },
  Page: {
    db: 3,
    ttl: 7200,
    name: "Pages",
  },
  GlobalLists: {
    db: 4,
    ttl: 14400,
    name: "Global Lists",
  },
  Tenant: {
    db: 5,
    ttl: 14400,
    name: "Tenants",
  },
  Person: {
    db: 6,
    ttl: 14400,
    name: "People",
  },
  TenantSchema: {
    db: 7,
    ttl: 14400,
    name: "Tenant Schemas",
  },
  WorkspacePages: {
    db: 8,
    ttl: 7200,
    name: "Workspace Pages (Sidebars)",
  },
  UserPermissions: {
    db: 9,
    ttl: 7200,
    name: "User Permissions",
  },
  General: {
    db: 11,
    ttl: 14400,
    name: "General",
  },
};

export default function CacheManagement() {
  return (
    <Container fluid>
      <div className="header pb-6">
        <AppPageHeader
          title="Cache Management"
          description="Clear Redis Caches used by the GrowthCloud API"
        />
        <BasicTableView
          items={Object.values(RedisDatabasesList)}
          loading={false}
          title={undefined}
          getItemTitle={(item) => item.name}
          getItemSubtitle={(item) => {
            return (
              <>
                Expiration:{" "}
                <span className="tw:font-medium tw:text-primary">
                  {item.ttl / 60} minutes
                </span>
              </>
            );
          }}
          CustomRenderer={(item) => (
            <IconButton
              icon="restart"
              onClick={() => clearRedisCache(item)}
              size="lg"
              color="danger"
              tooltipText="Clear Cache"
            />
          )}
        />
      </div>
    </Container>
  );

  async function clearRedisCache(item: { db: number; name: string }) {
    if (item.db < 1 || item.db > 11 || item.db === 10) {
      return newToastEvent("error", "Failed to clear cache. Invalid database.");
    }

    try {
      await API._bearerRequest(
        "PUT",
        `/mc-tools/clear-cache/${item.db}`,
        null,
        Cookies.get(`authenticationToken`)
      );

      newToastEvent("success", `Successfully cleared cache for ${item.name}`);
    } catch {
      newToastEvent("error", `Failed to clear cache for ${item.name}`);
    }
  }
}
